import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ICdOrderFieldsFragment = {
  id?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  projectId: any
  concreteDirectId: any
  deliveryId?: any | null
  startDate?: any | null
  localStartDate?: any | null
  externalId?: string | null
  timeZone: string
  orderReference?: string | null
  orderByPhone?: string | null
  orderByName?: string | null
  accountingReference?: string | null
  status: string
  progressPercent: number
  jobsiteId: string
  timeWindow: number
  sentToExternalBackend: boolean
  systemId: string
  costEstimationCalculated: boolean
  pricingPlantId: string
  printBatchWeights: boolean
  isPaperless: boolean
  isReviewNeeded: boolean
  isReservation: boolean
  deliveryInstructions?: string | null
  isManualDispatchAllowed: boolean
  isWaitingForDispatchSystem: boolean
  location?: { latitude: number; longitude: number } | null
  address?: {
    line: string
    city?: string | null
    state?: string | null
    zipCode: string
    country: string
  } | null
  orderItems?: Array<{
    id: string
    externalId?: string | null
    quantity: number
    isExactQuantity: boolean
    start?: any | null
    localStart?: any | null
    spacingInMinutes: number
    qtyPerHour: number
    rateType: string
    description: string
    pourMethod?: string | null
    pourElement?: string | null
    extendedPourElement?: string | null
    slump?: string | null
    payloadSize: number
    plantId: string
    jobsiteDistanceInMeters: number
    travelTimeInMinutes: number
    progressPercent: number
    itemId: string
    deliveredQuantity: number
    pouredQuantity: number
    holdQty: number
    currentTicketedQuantity: number
    currentBatchedQuantity: number
    actualSpacingInMinutes: number
    actualQtyPerHour: number
    item?: {
      id: string
      description: string
      status: string
      type: string
      unityOfMeasure: string
      externalId?: string | null
      systemId: string
      defaultSlump?: string | null
    } | null
    orderItemAdditions?: Array<{
      id: string
      externalId?: string | null
      quantity: number
      item?: {
        id: string
        description: string
        status: string
        type: string
        unityOfMeasure: string
        externalId?: string | null
      } | null
    } | null> | null
  } | null> | null
  orderCostEstimations?: Array<{
    id: string
    plantId: string
    travelTimeInMinutes: number
    calculatedDriveCost: number
    calculatedDriveCostCurrency: string
  } | null> | null
}

export type IGetConcreteDirectOrderByIdQueryVariables = Types.Exact<{
  cdId: Types.Scalars['Guid']['input']
}>

export type IGetConcreteDirectOrderByIdQuery = {
  concreteDirectOrder?: {
    id?: any | null
    createdAt?: any | null
    updatedAt?: any | null
    projectId: any
    concreteDirectId: any
    deliveryId?: any | null
    startDate?: any | null
    localStartDate?: any | null
    externalId?: string | null
    timeZone: string
    orderReference?: string | null
    orderByPhone?: string | null
    orderByName?: string | null
    accountingReference?: string | null
    status: string
    progressPercent: number
    jobsiteId: string
    timeWindow: number
    sentToExternalBackend: boolean
    systemId: string
    costEstimationCalculated: boolean
    pricingPlantId: string
    printBatchWeights: boolean
    isPaperless: boolean
    isReviewNeeded: boolean
    isReservation: boolean
    deliveryInstructions?: string | null
    isManualDispatchAllowed: boolean
    isWaitingForDispatchSystem: boolean
    location?: { latitude: number; longitude: number } | null
    address?: {
      line: string
      city?: string | null
      state?: string | null
      zipCode: string
      country: string
    } | null
    orderItems?: Array<{
      id: string
      externalId?: string | null
      quantity: number
      isExactQuantity: boolean
      start?: any | null
      localStart?: any | null
      spacingInMinutes: number
      qtyPerHour: number
      rateType: string
      description: string
      pourMethod?: string | null
      pourElement?: string | null
      extendedPourElement?: string | null
      slump?: string | null
      payloadSize: number
      plantId: string
      jobsiteDistanceInMeters: number
      travelTimeInMinutes: number
      progressPercent: number
      itemId: string
      deliveredQuantity: number
      pouredQuantity: number
      holdQty: number
      currentTicketedQuantity: number
      currentBatchedQuantity: number
      actualSpacingInMinutes: number
      actualQtyPerHour: number
      item?: {
        id: string
        description: string
        status: string
        type: string
        unityOfMeasure: string
        externalId?: string | null
        systemId: string
        defaultSlump?: string | null
      } | null
      orderItemAdditions?: Array<{
        id: string
        externalId?: string | null
        quantity: number
        item?: {
          id: string
          description: string
          status: string
          type: string
          unityOfMeasure: string
          externalId?: string | null
        } | null
      } | null> | null
    } | null> | null
    orderCostEstimations?: Array<{
      id: string
      plantId: string
      travelTimeInMinutes: number
      calculatedDriveCost: number
      calculatedDriveCostCurrency: string
    } | null> | null
  } | null
}

export type IListenCdOrderByIdSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IListenCdOrderByIdSubscription = {
  concreteDirectOrder?: {
    id?: any | null
    item?: {
      id?: any | null
      createdAt?: any | null
      updatedAt?: any | null
      projectId: any
      concreteDirectId: any
      deliveryId?: any | null
      startDate?: any | null
      localStartDate?: any | null
      externalId?: string | null
      timeZone: string
      orderReference?: string | null
      orderByPhone?: string | null
      orderByName?: string | null
      accountingReference?: string | null
      status: string
      progressPercent: number
      jobsiteId: string
      timeWindow: number
      sentToExternalBackend: boolean
      systemId: string
      costEstimationCalculated: boolean
      pricingPlantId: string
      printBatchWeights: boolean
      isPaperless: boolean
      isReviewNeeded: boolean
      isReservation: boolean
      deliveryInstructions?: string | null
      isManualDispatchAllowed: boolean
      isWaitingForDispatchSystem: boolean
      location?: { latitude: number; longitude: number } | null
      address?: {
        line: string
        city?: string | null
        state?: string | null
        zipCode: string
        country: string
      } | null
      orderItems?: Array<{
        id: string
        externalId?: string | null
        quantity: number
        isExactQuantity: boolean
        start?: any | null
        localStart?: any | null
        spacingInMinutes: number
        qtyPerHour: number
        rateType: string
        description: string
        pourMethod?: string | null
        pourElement?: string | null
        extendedPourElement?: string | null
        slump?: string | null
        payloadSize: number
        plantId: string
        jobsiteDistanceInMeters: number
        travelTimeInMinutes: number
        progressPercent: number
        itemId: string
        deliveredQuantity: number
        pouredQuantity: number
        holdQty: number
        currentTicketedQuantity: number
        currentBatchedQuantity: number
        actualSpacingInMinutes: number
        actualQtyPerHour: number
        item?: {
          id: string
          description: string
          status: string
          type: string
          unityOfMeasure: string
          externalId?: string | null
          systemId: string
          defaultSlump?: string | null
        } | null
        orderItemAdditions?: Array<{
          id: string
          externalId?: string | null
          quantity: number
          item?: {
            id: string
            description: string
            status: string
            type: string
            unityOfMeasure: string
            externalId?: string | null
          } | null
        } | null> | null
      } | null> | null
      orderCostEstimations?: Array<{
        id: string
        plantId: string
        travelTimeInMinutes: number
        calculatedDriveCost: number
        calculatedDriveCostCurrency: string
      } | null> | null
    } | null
  } | null
}

export const CdOrderFieldsFragmentDoc = gql`
  fragment CdOrderFields on ConcreteDirectOrder {
    id
    createdAt
    updatedAt
    projectId
    concreteDirectId
    deliveryId
    startDate
    localStartDate
    externalId
    timeZone
    location {
      latitude
      longitude
    }
    address {
      line
      city
      state
      zipCode
      country
    }
    orderItems {
      id
      externalId
      quantity
      isExactQuantity
      start
      localStart
      spacingInMinutes
      qtyPerHour
      rateType
      description
      pourMethod
      pourElement
      extendedPourElement
      slump
      payloadSize
      plantId
      jobsiteDistanceInMeters
      travelTimeInMinutes
      progressPercent
      itemId
      item {
        id
        description
        status
        type
        unityOfMeasure
        externalId
        systemId
        defaultSlump
      }
      deliveredQuantity
      pouredQuantity
      holdQty
      currentTicketedQuantity
      currentBatchedQuantity
      actualSpacingInMinutes
      actualQtyPerHour
      orderItemAdditions {
        id
        externalId
        quantity
        item {
          id
          description
          status
          type
          unityOfMeasure
          externalId
        }
      }
    }
    orderReference
    orderByPhone
    orderByName
    accountingReference
    status
    progressPercent
    jobsiteId
    timeWindow
    sentToExternalBackend
    systemId
    orderCostEstimations {
      id
      plantId
      travelTimeInMinutes
      calculatedDriveCost
      calculatedDriveCostCurrency
    }
    costEstimationCalculated
    pricingPlantId
    printBatchWeights
    isPaperless
    isReviewNeeded
    isReservation
    deliveryInstructions
    isManualDispatchAllowed
    isWaitingForDispatchSystem
  }
`
export const GetConcreteDirectOrderByIdDocument = gql`
  query GetConcreteDirectOrderById($cdId: Guid!) {
    concreteDirectOrder(cdId: $cdId) {
      ...CdOrderFields
    }
  }
  ${CdOrderFieldsFragmentDoc}
`

/**
 * __useGetConcreteDirectOrderByIdQuery__
 *
 * To run a query within a React component, call `useGetConcreteDirectOrderByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConcreteDirectOrderByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConcreteDirectOrderByIdQuery({
 *   variables: {
 *      cdId: // value for 'cdId'
 *   },
 * });
 */
export function useGetConcreteDirectOrderByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetConcreteDirectOrderByIdQuery,
    IGetConcreteDirectOrderByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetConcreteDirectOrderByIdQuery,
    IGetConcreteDirectOrderByIdQueryVariables
  >(GetConcreteDirectOrderByIdDocument, options)
}
export function useGetConcreteDirectOrderByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetConcreteDirectOrderByIdQuery,
    IGetConcreteDirectOrderByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetConcreteDirectOrderByIdQuery,
    IGetConcreteDirectOrderByIdQueryVariables
  >(GetConcreteDirectOrderByIdDocument, options)
}
export type GetConcreteDirectOrderByIdQueryHookResult = ReturnType<
  typeof useGetConcreteDirectOrderByIdQuery
>
export type GetConcreteDirectOrderByIdLazyQueryHookResult = ReturnType<
  typeof useGetConcreteDirectOrderByIdLazyQuery
>
export type GetConcreteDirectOrderByIdQueryResult = Apollo.QueryResult<
  IGetConcreteDirectOrderByIdQuery,
  IGetConcreteDirectOrderByIdQueryVariables
>
export const ListenCdOrderByIdDocument = gql`
  subscription ListenCdOrderById($id: ObjectId!) {
    concreteDirectOrder(id: $id) {
      id
      item {
        ...CdOrderFields
      }
    }
  }
  ${CdOrderFieldsFragmentDoc}
`

/**
 * __useListenCdOrderByIdSubscription__
 *
 * To run a query within a React component, call `useListenCdOrderByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenCdOrderByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenCdOrderByIdSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useListenCdOrderByIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenCdOrderByIdSubscription,
    IListenCdOrderByIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenCdOrderByIdSubscription,
    IListenCdOrderByIdSubscriptionVariables
  >(ListenCdOrderByIdDocument, options)
}
export type ListenCdOrderByIdSubscriptionHookResult = ReturnType<
  typeof useListenCdOrderByIdSubscription
>
export type ListenCdOrderByIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenCdOrderByIdSubscription>
